import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const heroTextShadow = {
  textShadow: '0 2px 12px rgba(0,0,0,0.7), 0 1px 3px rgba(0,0,0,0.5)'
};
export function Hero() {
  return <section id="home" className="relative min-h-[100svh] flex items-center justify-center parallax-bg pt-20" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/vVs6YoVLN7rRFePZDEQBCu/kbella_services.webp)'
  }} data-id="element-128">
      <div className="absolute inset-0 z-0" style={{
      background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.75) 100%)'
    }} data-id="element-129"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center flex flex-col items-center" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-131">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold leading-tight mb-6 text-white" style={heroTextShadow} data-id="element-132">
            Enhancing Your Natural Beauty & Boosting Your Confidence
          </h1>

          <p className="text-lg md:text-xl lg:text-2xl font-light mb-10 max-w-3xl mx-auto tracking-wide" style={{
          color: '#F0F0F0',
          ...heroTextShadow
        }} data-id="element-133">
            Maricopa's premier destination for advanced skincare, permanent
            makeup & rejuvenation — 16+ years of trusted expertise.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-134">
            <a href="#contact" className="w-full sm:w-auto bg-brand-teal text-white px-8 py-4 rounded-sm font-semibold text-lg hover:bg-teal-500 transition-colors min-h-[48px] flex items-center justify-center" style={heroTextShadow} data-id="element-135">
              Book Your Appointment
            </a>
            <a href="#services" className="w-full sm:w-auto bg-transparent border-2 border-white text-white px-8 py-4 rounded-sm font-semibold text-lg hover:bg-white/15 transition-colors min-h-[48px] flex items-center justify-center" style={heroTextShadow} data-id="element-136">
              Explore Services
            </a>
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-137">
            <div className="flex items-center gap-1 text-brand-teal" data-id="element-138">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-139" />)}
            </div>
            <p className="text-sm md:text-base font-semibold tracking-widest uppercase text-white" style={heroTextShadow} data-id="element-140">
              Serving Maricopa for 16+ Years · Internationally Trained · By
              Appointment Only
            </p>
            <a href="tel:5202338576" className="text-xl md:text-2xl font-heading mt-2 text-white hover:text-brand-teal transition-colors" style={heroTextShadow} data-id="element-141">
              (520) 233-8576
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}